import e from "./Layout.module.js";
import { c as t } from "react/compiler-runtime";
import n from "classnames";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/Layout/Layout.tsx
var i = (i) => {
	let a = t(5), { children: o, className: s } = i, c = s === void 0 ? "" : s, l;
	a[0] === c ? l = a[1] : (l = n(e.horizontalPadding, c), a[0] = c, a[1] = l);
	let u;
	return a[2] !== o || a[3] !== l ? (u = /* @__PURE__ */ r("div", {
		className: l,
		children: o
	}), a[2] = o, a[3] = l, a[4] = u) : u = a[4], u;
};
//#endregion
export { i as Layout, e as layoutStyles };
